import React, { lazy, Component } from 'react';
import { MapPin, Home, Clock, Smartphone, Package, MessageCircle } from 'lucide-react';
import { WA_NUMBER } from '../data/products';
export function LocationSection() {
  const waLink = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hola! Quiero coordinar un Pick Up para los suplementos')}`;
  return <section className="bg-gradient-to-b from-dark-900 via-dark-700 to-dark-900 py-[80px] px-5" id="ubicacion" data-id="element-180">
      <div className="max-w-[1100px] mx-auto" data-id="element-181">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white" data-id="element-182">
          Encontranos en AlphaFit
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-183">
          Vení a conocernos o mandanos un WhatsApp antes de venir
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center" data-id="element-184">
          <div data-id="element-185">
            <h3 className="text-[1.5rem] font-black uppercase tracking-[2px] mb-5 text-alphaGold flex items-center gap-2" data-id="element-186">
              <MapPin className="w-6 h-6" data-id="element-187" /> Nuestra Ubicación
            </h3>

            <div className="flex items-start gap-4 mb-5" data-id="element-188">
              <Home className="w-6 h-6 text-alphaGold flex-shrink-0 mt-0.5" data-id="element-189" />
              <div data-id="element-190">
                <strong className="block text-white text-[0.9rem] uppercase tracking-[1px] mb-1" data-id="element-191">
                  Zona Pick Up
                </strong>
                <span className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-192">
                  Malvín, Montevideo, Uruguay
                </span>
              </div>
            </div>

            <div className="flex items-start gap-4 mb-5" data-id="element-193">
              <Clock className="w-6 h-6 text-alphaGold flex-shrink-0 mt-0.5" data-id="element-194" />
              <div data-id="element-195">
                <strong className="block text-white text-[0.9rem] uppercase tracking-[1px] mb-1" data-id="element-196">
                  Horario de Atención
                </strong>
                <span className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-197">
                  Lunes a Sábados: 10:00 — 18:00 hs
                  <br data-id="element-198" />
                  Domingo: Cerrado
                </span>
              </div>
            </div>

            <div className="flex items-start gap-4 mb-5" data-id="element-199">
              <Smartphone className="w-6 h-6 text-alphaGold flex-shrink-0 mt-0.5" data-id="element-200" />
              <div data-id="element-201">
                <strong className="block text-white text-[0.9rem] uppercase tracking-[1px] mb-1" data-id="element-202">
                  WhatsApp
                </strong>
                <span className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-203">
                  +{WA_NUMBER.substring(0, 3)} {WA_NUMBER.substring(3, 5)}{' '}
                  {WA_NUMBER.substring(5, 8)} {WA_NUMBER.substring(8)}
                </span>
              </div>
            </div>

            <div className="flex items-start gap-4 mb-5" data-id="element-204">
              <Package className="w-6 h-6 text-alphaGold flex-shrink-0 mt-0.5" data-id="element-205" />
              <div data-id="element-206">
                <strong className="block text-white text-[0.9rem] uppercase tracking-[1px] mb-1" data-id="element-207">
                  Envíos
                </strong>
                <span className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-208">
                  Desde $190 UY · Varía según zona de entrega
                </span>
              </div>
            </div>

            <div className="flex flex-wrap gap-2.5 mt-5" data-id="element-209">
              <a href="https://www.google.com/maps/search/Malvín+Montevideo+Uruguay" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-transparent border-2 border-alphaGold text-alphaGold text-[0.85rem] font-extrabold py-3 px-6 rounded uppercase tracking-[1px] transition-colors duration-300 hover:bg-alphaGold hover:text-white" data-id="element-210">
                <MapPin className="w-4 h-4" data-id="element-211" /> Ver en Google Maps
              </a>
              <a href={waLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-transparent border-2 border-alphaGold text-alphaGold text-[0.85rem] font-extrabold py-3 px-6 rounded uppercase tracking-[1px] transition-colors duration-300 hover:bg-alphaGold hover:text-white" data-id="element-212">
                <MessageCircle className="w-4 h-4" data-id="element-213" /> WhatsApp
              </a>
            </div>
          </div>

          <div data-id="element-214">
            <div className="rounded-lg overflow-hidden border-2 border-alphaGold h-[320px]" data-id="element-215">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26186.416246419514!2d-56.11776510309653!3d-34.88725176506456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x959f81216503b081%3A0x8681b9e2c6598c0b!2sMalv%C3%ADn%2C%20Montevideo%2C%20Departamento%20de%20Montevideo!5e0!3m2!1ses!2suy!4v1700000000000!5m2!1ses!2suy" allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="AlphaFit - Malvín, Montevideo" className="w-full h-full border-none" data-id="element-216"></iframe>
            </div>
            <p className="text-[#555] text-[0.8rem] mt-2.5 text-center" data-id="element-217">
              Hacé click en el mapa para abrir en Google Maps y obtener
              indicaciones
            </p>
          </div>
        </div>
      </div>
    </section>;
}